// extracted by mini-css-extract-plugin
module.exports = {"root":"Errors_root__1MviM","errors":"Errors_errors__Pq-ai"};